import { Component, computed, Signal } from '@angular/core';
import { environment } from '@env/environment';
import { ErrorInputs, ErrorService } from '@shared/services/error.service';

@Component({
  selector: 'pl-login-shell',
  templateUrl: './login-shell.component.html',
  styleUrls: ['./login-shell.component.css'],
})
export class LoginShellComponent {
  public version: string | null = environment.version;

  constructor(private errorService: ErrorService) {}

  public error: Signal<ErrorInputs | null> = computed(() => this.errorService.getError());
}
